import i18n from "../i18n" /* useTranslation hookは使用できない */
import {isAmOne} from "../common"

const termDefinitions = {
  FX: [ `D20N`, `D60N`, `D120N`, `D250N` ],
  EQ: [ `D20N`, `D60N`, `D120N`, `D250N`, `W208N`, `M120N`, `Q60N` ],
  EQSET: [ `D20N`, `D60N`, `D120N`, `D250N` ],
}

const amOneDefinitions = {
  FXSET: [ `W208N`, `M120N`, `Q60N` ],
  EQSET: [ `D20N`, `D60N`, `D120N`, `D250N` ],
}

/** 各タブのTermリストを作成 */
export const defineTerms = (mainType, mainGroup) => {
  var def = isAmOne() ? amOneDefinitions : termDefinitions
  var value = mainGroup.map((gr, i) => {
    return def[mainType[i]].map((tr) => {
      return {
        key: tr,
        label: i18n.t(tr), /* i18next-extract-disable-line */
        labelJa: i18n.t(`${tr}_JA`),  /* i18next-extract-disable-line */
        labelEn: i18n.t(`${tr}_EN`),  /* i18next-extract-disable-line */
      }
    })
  })

  return value
}
